import { SiteSectionIds } from '../../../../contentful';
import {
	SiteSectionSlug,
	siteSectionSlugValues,
} from '../../../../features/app/pages/domain/constants/siteSectionSlug';

const siteSectionIdToSlugMap: {
	[key in SiteSectionIds]?: SiteSectionSlug;
} = {
	[SiteSectionIds.Passengers]: SiteSectionSlug.Passengers,
	[SiteSectionIds.Business]: SiteSectionSlug.Business,
	[SiteSectionIds.Careers]: SiteSectionSlug.Careers,
	[SiteSectionIds.OXD]: SiteSectionSlug.OXD,
	[SiteSectionIds.CvgElevate]: SiteSectionSlug.CvgElevate,
};

const siteSectionSlugToIdMap: {
	[key in SiteSectionSlug]?: SiteSectionIds;
} = {
	[SiteSectionSlug.Passengers]: SiteSectionIds.Passengers,
	[SiteSectionSlug.Business]: SiteSectionIds.Business,
	[SiteSectionSlug.Careers]: SiteSectionIds.Careers,
	[SiteSectionSlug.OXD]: SiteSectionIds.OXD,
	[SiteSectionSlug.CvgElevate]: SiteSectionIds.CvgElevate,
};

export const getCurrentSiteSectionSlug = (
	id?: string | SiteSectionIds,
): SiteSectionSlug =>
	siteSectionIdToSlugMap[id as SiteSectionIds] ||
	siteSectionIdToSlugMap[SiteSectionIds.Passengers]!;

export const getCurrentSiteSectionId = (url: string) => {
	const siteSectionSlug = getCurrentWebsiteSlugFromUrl(url);

	return siteSectionSlugToIdMap[siteSectionSlug] || SiteSectionIds.Passengers;
};

export const getCurrentWebsiteSlugFromUrl = (url: string) => {
	const pathSegments = url
		.toLowerCase()
		.split('/')
		.map((part) => part.trim())
		.filter(Boolean);

	const siteSectionSlug = pathSegments.find((segment) =>
		siteSectionSlugValues.has(segment as SiteSectionSlug),
	);

	return siteSectionSlug as SiteSectionSlug;
};
